// extracted by mini-css-extract-plugin
module.exports = {"root":"CommonControlButtons_root__22q_w"};